import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetSuscriberOrganization = async (organizationId) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('subscribers') +
    `/getAllSubscriberCorpEntities/${organizationId}?offset=0&limit=100`

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
